import styled from "styled-components";
import {XCloseButtonBox} from "../../../../basic-ui-components/x-close-button/x-close-button.box";

export const AdvancedGamesFilterCloseButtonBox = styled(XCloseButtonBox)`
    width: 20px;
    height: 20px;
`